import React, { useState, useEffect } from "react";
import { useHistory, Link } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import { Row, Col } from "react-bootstrap";
import { useCookies } from "react-cookie";
import { axiosRequest } from "../axiosConfig";
import { clearAllCookies, redirectToLogin } from "../Utils";
import packageJson from "../../package.json";

import {
  AppBar,
  Box,
  Button,
  IconButton,
  Stack,
  Toolbar,
  Typography,
} from "@mui/material";
import { Logout } from "@mui/icons-material";

function Navbar() {
  const history = useHistory();
  const [click, setClick] = useState(false);
  const [cookies] = useCookies();
  const closeMobileMenu = () => setClick(false);
  const [currentVersion, setCurrentVersion] = useState("");

  const { major, minor, patch } = packageJson.versionConfig.version;
  const appVersion = `${major}.${minor}.${patch}`;

  // When refresh then reload the page.
  const refresh = () => {
    window.location.reload(false);
  };

  // On Log out release the fax lock.
  const LogOutFunction = async () => {
    axiosRequest
      .get(`${process.env.REACT_APP_BaseUrl}releaselocks`)
      .then((res) => {})
      .catch((err) => {
        console.log(err, "releaselocks");
      });
    clearAllCookies();
    window?.location?.replace(`${window?.location?.origin}`);
  };
  const getSystemVersion = () => {
    if (currentVersion == "") {
      axiosRequest
        .get(`${process.env.REACT_APP_BaseUrl}getsystemversion`)
        .then((res) => {
          setCurrentVersion(res.data);
        })
        .catch((err) => {
          console.log(err, "getsystemversion");
        });
    }
  };

  const redirectIndexPage = () => {
    history.push({
      pathname: "/home",
      state: { indexPageState: history.location.state.indexPageState },
    });
  };


  return (
    <AppBar
      position="static"
      elevation={0}
      sx={{
        bgcolor: "background.paper",
        borderBottom: "1px solid",
        borderColor: "grey.200",
      }}
    >
      <Toolbar sx={{ px: 3 }}>
        {/* Left section - Logo and Product Name */}
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography
            // component={Button}
            onClick={redirectIndexPage}
            color="#00AB4E"
            sx={{
              textDecoration: "none",
              fontSize: "1.1rem",
              cursor: "pointer",
              "&:hover": {
                color: "#008C40", // Darker green on hover
              },
              transition: "color 0.3s", // Smooth transition for the hover effect
            }}
          >
            Intelligent Intake by Celeritas AI
          </Typography>
          <Box
            sx={{
              height: "24px",
              borderLeft: "1px solid",
              borderColor: "grey.300",
              mx: 2,
            }}
          />
          <Typography
            sx={{
              color: "text.primary",
              fontSize: "1.1rem",
            }}
          >
            Celeritas AI
          </Typography>
          <Typography
            variant="caption"
            sx={{
              color: "text.secondary",
              ml: 1,
            }}
          >
            v.{appVersion}
          </Typography>
        </Stack>

        {/* Right section - Welcome message and Logout */}
        <Stack
          direction="row"
          spacing={2}
          alignItems="center"
          sx={{ ml: "auto" }}
        >
          <Typography color="text.secondary" sx={{ fontSize: "1rem" }}>
            Welcome, {cookies?.firstName} {cookies?.lastName}
          </Typography>
          <IconButton
            onClick={LogOutFunction}
            sx={{
              color: "text.secondary",
              "&:hover": {
                bgcolor: "grey.100",
              },
            }}
          >
            <Logout size={20} />
          </IconButton>
        </Stack>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
